/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Currency = "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "%future added value" | "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type PdpSharedBlurbShipping_shipmentQuote = {
    readonly isCustom: boolean | null;
    readonly isNew: boolean | null;
    readonly status: string | null;
    readonly subTotalAmount: {
        readonly amount: number | null;
    } | null;
    readonly buyerSubTotalAmount: {
        readonly convertedAmountList: ReadonlyArray<{
            readonly currency: Currency | null;
            readonly amount: number | null;
        } | null> | null;
    } | null;
    readonly serviceMethod: {
        readonly isWhiteGlove: boolean | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingInfoLink_shipmentQuote" | "PdpSharedShippingInfo_shipmentQuote">;
    readonly " $refType": "PdpSharedBlurbShipping_shipmentQuote";
};
export type PdpSharedBlurbShipping_shipmentQuote$data = PdpSharedBlurbShipping_shipmentQuote;
export type PdpSharedBlurbShipping_shipmentQuote$key = {
    readonly " $data"?: PdpSharedBlurbShipping_shipmentQuote$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedBlurbShipping_shipmentQuote">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "amount",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "PdpSharedBlurbShipping_shipmentQuote",
  "type": "ShipmentQuote",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isCustom",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "isNew",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "status",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "subTotalAmount",
      "storageKey": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "buyerSubTotalAmount",
      "storageKey": null,
      "args": null,
      "concreteType": "FinancialAmount",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "convertedAmountList",
          "storageKey": null,
          "args": null,
          "concreteType": "ConvertedAmountList",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "currency",
              "args": null,
              "storageKey": null
            },
            (v0/*: any*/)
          ]
        }
      ]
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "serviceMethod",
      "storageKey": null,
      "args": null,
      "concreteType": "ShipmentServiceMethod",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "isWhiteGlove",
          "args": null,
          "storageKey": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfoLink_shipmentQuote",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedShippingInfo_shipmentQuote",
      "args": null
    }
  ]
};
})();
(node as any).hash = 'd5c24586a637b472559d75cc51d9a8fe';
export default node;
